'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var languages = require('./languages.cjs');
var constants = require('./constants.cjs');
var i18n = require('./i18n.cjs');
var dates = require('./dates.cjs');

"use strict";

exports.LANGUAGES = languages.LANGUAGES;
exports.BRAZILIAN_PORTUGUESE = constants.BRAZILIAN_PORTUGUESE;
exports.CHINESE_SIMPLIFIED = constants.CHINESE_SIMPLIFIED;
exports.CHINESE_TRADITIONAL = constants.CHINESE_TRADITIONAL;
exports.CZECH_CZECHIA = constants.CZECH_CZECHIA;
exports.DEFAULT_LANGUAGE = constants.DEFAULT_LANGUAGE;
exports.DUTCH_NETHERLANDS = constants.DUTCH_NETHERLANDS;
exports.ENGLISH_US = constants.ENGLISH_US;
exports.FRENCH_FRANCE = constants.FRENCH_FRANCE;
exports.GERMAN_GERMANY = constants.GERMAN_GERMANY;
exports.HUNGARIAN_HUNGARY = constants.HUNGARIAN_HUNGARY;
exports.INDONESIAN_INDONESIA = constants.INDONESIAN_INDONESIA;
exports.ITALIAN_ITALY = constants.ITALIAN_ITALY;
exports.JAPANESE_JAPAN = constants.JAPANESE_JAPAN;
exports.KOREAN_KOREA = constants.KOREAN_KOREA;
exports.POLISH_POLAND = constants.POLISH_POLAND;
exports.PORTUGUESE_PORTUGAL = constants.PORTUGUESE_PORTUGAL;
exports.PSEUDO_LOCALE = constants.PSEUDO_LOCALE;
exports.RUSSIAN_RUSSIA = constants.RUSSIAN_RUSSIA;
exports.SPANISH_SPAIN = constants.SPANISH_SPAIN;
exports.SWEDISH_SWEDEN = constants.SWEDISH_SWEDEN;
exports.TURKISH_TURKEY = constants.TURKISH_TURKEY;
exports.Trans = i18n.Trans;
exports.initPluginTranslations = i18n.initPluginTranslations;
exports.t = i18n.t;
exports.formatDate = dates.formatDate;
exports.formatDateRange = dates.formatDateRange;
exports.formatDuration = dates.formatDuration;
exports.initRegionalFormatForTests = dates.initRegionalFormat;
//# sourceMappingURL=index.cjs.map
